<template>
			<div class="text_wrap">
			   <!--<input type="button" value="后退" onclick="window.history.go(-1)"/>-->
			   <h3 class="text_title_style" style="text-align: center;">最终用户协议</h3>
			　　<h4>重要须知：</h4>
			　　<p>本协议是您（个人或单一实体）与本平台之间关于平台向您提供平台所涉相关服务的法律协议。在此特别提醒，开发者（您）欲使用相关服务，必须事先认真阅读本服务条款中各条款，包括免除或者限制开发者责任的免责条款及对用户的权利限制。请您审阅并接受或不接受本服务条款（未成年人审阅时应得到法定监护人的陪同）。本服务条款一旦发生变更,将在网页上公布修改内容。修改后的服务条款一旦在网页上公布即有效代替原来的服务条款。</p>
			　　 <p>您若不同意对服务条款的修改，您应不使用或主动取消相关服务，否则，您的任何对相关服务的登陆、查看等使用行为将被视为您对相关修改和本协议的理解和接受。</p>
			　　<p>如果您选择接受本协议开通服务，即表示您同意接受协议各项条件的约束。如果您不同意本服务条款，则不能获得使用本服务的权利。您若有违反本条款的任何规定，平台有权随时中止或终止您服务的使用资格并保留追究相关法律责任的权利</p>
			   <h4>* 如无特别说明，下列术语在本协议中的含义为：</h4>
			   <p>平台：指经有效申请并经过小豚教育云平台（以下简称平台）的运营公司（以下简称公司）同意，将其开发的或有权的各种应用接入基于平台而向用户提供各种服务的，具备民事行为能力的个人、法人或其他组织。</p>
			   <p>应用：指由开发者开发的可向用户提供各种服务的应用程序，包括但不限于教育教学服务、工具类服务、在线课程类服务或视频类服务等现存的各种服务及今后可能出现的各种服务。</p>
			   <p><strong>第一条</strong> 本平台及服务由平台开发，受中华人民共和国版权法及国际版权条约和其他知识产权法及条约的保护。</p>
			   <p><strong>第二条</strong> 开发者在遵守法律及本条款的前提下可依本协议使用应用及享受服务，但开发者无权实施包括但不限于下列行为：</p>
			   <p>2.1 删除应用及其他副本上所有关于版权的信息、内容。</p>
			   <p>2.2 对应用进行反向工程、反向汇编、反向编译等。</p>
			   <p>2.3 对于应用中相关信息等，未经本应用平台及相关开发者书面同意，开发者不得擅自实施包括但不限于下列行为：使用、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助“软件”发展与之有关的衍生产品、作品等。</p>
			   <p>2.4利用应用及服务发表、传送、传播、储存危害国家安全、祖国统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容或者设置含有上述内容的网名、角色名。</p>
			   <p>2.5 利用应用及服务发表、传送、传播、储存侵害他人知识产权、商业机密权、肖像权、隐私等合法权利的内容。</p>
			   <p>2.6进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP 数据包名称或部分名称。</p>
			   <p>2.7进行任何破坏应用服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众。</p>
			   <p>2.8 进行任何诸如发布广告、销售商品的商业行为，或者进行任何非法的侵害平台利益的行为。</p>
			   <p>2.9 冒充平台、应用服务管理员发布任何诈骗或虚假信息。</p>
			   <p><strong>第三条</strong> 使用本服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本条款，对于用户违法或违反本协议的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。</p>
			   <p><strong>第四条</strong> 尊重用户个人隐私信息的私有性是本应用及服务的原则，平台将会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，未经开发者同意不向第三方公开、透露开发者个人隐私信息。</p>
			   <p><strong>第五条</strong> 开发者应规范、合法地使用本应用及服务，如用户有在公共环境下捣乱、骚扰、欺骗其他用户等行为或者实施其他违反本协议的行为，一经发现，开发者有权停止服务。</p>
			   <p><strong>第六条</strong> 账号注册</p>
			   <p>（1）开发者承诺以其真实身份注册成为开发者的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和相关法规规定的必备条款约定对所提供的信息承担相应的法律责任。</p>
			   <p>（2）开发者以其真实身份注册成为开发者用户后，需要修改所提供的个人身份资料信息的，开发者应当及时、有效地为其提供该项服务。</p>
			   <p><strong>第七条</strong> 账号使用与保管</p>
			   <p>（1）平台有权审查开发者注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；开发者有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。</p>
			   <p>（2）开发者对登录后所持账号产生的行为依法享有权利和承担责任。</p>
			   <p>（3）开发者发现其账号或密码被他人非法使用或有使用异常的情况的，应及时通知平台，并有权通知开发者采取措施暂停该账号的登录和使用。</p>
			   <p>（4）平台根据开发者的通知采取措施暂停开发者账号的登录和使用的，平台应当要求开发者提供并核实与其注册身份信息相一致的个人有效身份信息。</p>
			   <p>（5）平台核实开发者所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停开发者账号的登录和使用。</p>
			   <p>（6）开发者违反第（5）项的约定，未及时采取措施暂停平台账号的登录和使用，因此而给平台造成损失的，应当承担其相应的法律责任。</p>
			   <p>（7）开发者没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，平台有权拒绝开发者上述请求。</p>
			   <p>（8）开发者为了维护其合法权益，向平台提供与所注册的身份信息相一致的个人有效身份信息时，平台应当为开发者提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
			   <p><strong>第八条</strong> 服务的中止与终止</p>
			   <p>（1）开发者有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，平台有权立即终止对用户提供服务。</p>
			   <p>（2）开发者在接受应用服务时实施违反约定或相关法规的不正当行为的，平台有权终止对用户提供服务。</p>
			   <p>（3）开发者提供虚假注册身份信息，或实施违反本协议或相关法规的行为，平台有权中止对开发者提供全部或部分服务；平台采取中止措施会以合适的方式通知开发者并告知中止期间，中止期间是合理的，中止期间届满开发者应当及时恢复对用户的服务。</p>
			   <p>（4）平台根据本条约定中止或终止对开发者提供部分或全部服务的，平台应负举证责任。</p>
			   <p><strong>第九条</strong> 开发者信息保护</p>
			   <p>（1）平台要求开发者提供与其个人身份有关的信息资料时，会事先以明确而易见的方式向开发者公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护开发者及所有用户的个人信息资料的安全。</p>
			   <p>（2）未经开发者许可平台不得向任何第三方提供、公开或共享开发者注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：</p>
			   <p>A. 开发者或开发者监护人授权开发者披露的；</p>
			   <p>B. 有关法律要求平台披露的；</p>
			   <p>C. 司法机关或行政机关基于法定程序要求平台提供的；</p>
			   <p>D.平台为了维护自己合法权益而向开发者提起诉讼或者仲裁时；</p>
			   <p>E.应开发者监护人的合法要求而提供开发者个人身份信息时。</p>
			   <p><strong>第十条</strong> 平台及开发者均承诺遵守与本公司签订的及各种规范、规则等所有条款及本公司对这些服务的更新。</p>
			   <p><strong>第十一条</strong> 本服务条款的解释，效力及纠纷的解决，适用于中华人民共和国大陆法律。若发生任何纠纷或争议，应当友好协商解决，协商不成的，均应提交北京市海淀区人民法院解决。</p>
			   <p>（完）</p>
			</div>
</template>

<script>
	
	export default {
		name: 'agreement_register',
		data() {
			return {
				
			}
		},
		created: function() {
			
		},
		methods: {
			
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// agreement_register.vue?0a2b6a96